import { createSlice, PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
import { EditUserInfo, EditUserInfoFieldUpdate, UserInfo } from '@repo/user-types'

const initialState: GenericOperationState<UserInfo | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: userInfoDataActions, reducer: userInfoDataReducer } = createOperationSlice<
  UserInfo | null,
  SliceCaseReducers<GenericOperationState<UserInfo | null>>
>({
  name: '@users/userInfo',
  initialState,
  reducers: {},
})

const editInitialState: GenericOperationState<null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: editUserInfoActions, reducer: editUserInfoReducer } = createOperationSlice<
  null,
  SliceCaseReducers<GenericOperationState<null>>,
  UserInfo
>({
  name: '@users/editUserInfo',
  initialState: editInitialState,
  reducers: {},
})

const editUserInfoInitialState = {} as EditUserInfo

export const { actions: editUserDataActions, reducer: editUserDataReducer } = createSlice({
  name: '@users/userInfo/contactData',
  initialState: editUserInfoInitialState,
  reducers: {
    initializeData: (state, { payload }: PayloadAction<UserInfo>) => {
      return Object.assign(
        {
          ...payload.correspondenceAddress,
          ...payload.personalData,
          fiscalData: {
            recipient: payload.taxData.recipient,
            streetType: payload.taxData.streetType,
            streetName: payload.taxData.streetName ?? '',
            streetNumber: payload.taxData.streetNumber ?? '',
            city: payload.taxData.city ?? '',
            province: payload.taxData.province,
            postalCode: payload.taxData.postalCode ?? '',
            residenceCountry: payload.taxData.residenceCountry,
          },
          email: payload.contactData.email,
          personalPhone: {
            prefix: payload.contactData.landlinePhonePrefix ?? '+34',
            number: payload.contactData.landlinePhone,
          },
          mobilePhone: {
            prefix: payload.contactData.mobilePhonePrefix ?? '+34',
            number: payload.contactData.mobilePhone,
          },
          emailConfirm: state.email ?? payload.contactData.email ?? '',
        },
        state,
      )
    },
    updateField: (state: EditUserInfo, { payload }: PayloadAction<EditUserInfoFieldUpdate>) => {
      const { field, value } = payload

      return {
        ...state,
        [field]: value,
      }
    },
    setData: (_state: EditUserInfo, { payload }: PayloadAction<EditUserInfo>) => {
      return payload
    },
    clearData: () => editUserInfoInitialState,
  },
})
